const RaceClassTag = ({ children, onDelete, ...props }) => {
  return (
    <span
      className='bg-info p-1 d-flex align-items-center gap-2'
      style={{ width: 'fit-content' }}
    >
      {children}
      <button
        onClick={() => onDelete()}
        className='btn-close'
        style={{ fontSize: '16px' }}
      />
    </span>
  );
};

export default RaceClassTag;
